<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="headline">{{$t('bulkMadAllRequestSupport')|capitalize}}</span>
            </v-card-title>
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-select
                            :items="ls_types"
                            v-model="ls_type"
                        ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                        <div class="text-xs-right">
                            <v-btn color="error" class="add-custom-info" @click="openConfirmBulkMAD()">
                                {{$t('bulkMadAllButton')|capitalize}}
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-dialog v-model="showDialogConfirmBulkMAD" width="500" persistent>
                <v-card>
                    <div class="fti-dialog-header">
                        <div class="ml-3">{{$t('bulkMadAllRequestSupport')|capitalize}}</div>
                        <v-spacer></v-spacer>
                        <v-btn flat icon @click="showDialogConfirmBulkMAD = false">
                            <v-icon color="#fff">mdi-close</v-icon>
                        </v-btn>
                    </div>
                    <div class="text-xs-center my-3">
                        <span v-if="ls_type==='all'">{{$t('bulkMADAllConfirm')|capitalize}}</span>
                        <span v-else-if="ls_type==='not_assigned'">{{$t('bulkMADNotAssignedConfirm')|capitalize}}</span>
                        <span v-else-if="ls_type==='assigned'">{{$t('bulkMADAssignedConfirm')|capitalize}}</span>
                    </div>
                    <div class="text-xs-center">
                        <v-btn class="add-custom-info" color="error" @click="confirmBulkMAD">
                            {{$t('bulkMadAllButton')|capitalize}}
                        </v-btn>
                        <v-btn class="add-custom-info" color="grey" @click="showDialogConfirmBulkMAD = false">
                            {{$t('cancel')|capitalize}}
                        </v-btn>
                    </div>
                    <div class="chat_view_loading" v-if="loadingDialog">
                        <div class="loading_overlay"></div>
                        <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
                    </div>
                </v-card>
            </v-dialog>
            <div class="chat_view_loading" v-if="loadingDialog">
                <div class="loading_overlay"></div>
                <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
            </div>
        </v-card>
    </v-container>
</template>
<script>
import BotService from "@/services/bot.service";
import {mapActions} from "vuex";

export default {
        name: "BulkMAD",
        props: {
            botCode: String
        },
        data() {
            return {
                loadingDialog: false,
                showDialogConfirmBulkMAD: false,
                ls_types: [
                    {text: this.$t('bulkMADAll'), value: 'all'},
                    {text: this.$t('bulkMADNotAssigned'), value: 'not_assigned'},
                    {text: this.$t('bulkMADAssigned'), value: 'assigned'},
                ],
                ls_type: "all"
            }
        },
        methods: {
            ...mapActions('dialog', ['closeDialogBlockCustomer']),
            openConfirmBulkMAD() {
                this.showDialogConfirmBulkMAD = true;
            },
            confirmBulkMAD() {
                this.loadingDialog = true;
                BotService.bulkMAD(this.botCode, this.ls_type).then(() => {
                    this.$AppService.toastSuccess(this.$t("bulkMADSuccess"));
                }).catch((e) => {
                    console.error(e)
                    this.$AppService.toastError(this.$t("bulkMADFailed"));
                }).finally(() => {
                    this.loadingDialog = false;
                    this.showDialogConfirmBulkMAD = false;
                })
            }
        }
    }
</script>

<style scoped>
    ::v-deep .v-card {
        border-radius: 4px !important;
    }

    .add-custom-info {
        color: #FFFFFF;
        text-transform: none;
        font-weight: bold;
        border-radius: 5px !important;
        margin-left: 0px !important;
    }

    .headline {
        color: #FFFFFF;
        font-size: 18px !important;
        line-height: 30px;
    }

    .fti-dialog-header {
        display: flex;
        align-items: center;
        background: #0052CC;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        height: 40px;
    }
</style>
<style scoped lang="scss">
    @import "../../components/style/variables.scss";
    .chat_view_loading {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 99999;
        align-items: center;
        text-align: center;
        padding-top: 5%;

        .loading_overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            background-color: black;
            opacity: 0.2;
        }
    }
</style>
